const removeBodyCSS = () => {
    const bodyCSS = ["body_default", "body_login", "body_inbox", "body_portal"];
    const removeClass = (arr) => {
        arr.forEach(ele => {
            document.body.classList.remove(ele);
        });
    };
    removeClass(bodyCSS);
};

export default removeBodyCSS;